<template>
  <label
    class="text-left font-medium mb-2 flex"
    :class="{ 'text-sm': size === 'small' }"
    ><slot
  /></label>
</template>

<script>
export default {
  props: {
    size: String,
  },
};
</script>

<style></style>
